import { useState, useEffect } from 'react';

export default function CustomAssistantButton() {
  const [isHovered, setIsHovered] = useState(false);
  const [isTalking, setIsTalking] = useState(false);

  useEffect(() => {
    // Detectar cuando el asistente está activo
    const checkAssistantStatus = setInterval(() => {
      const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
      if (widget) {
        const isActive = widget.getAttribute('data-vapi-active') === 'true';
        setIsTalking(isActive);
      }
    }, 500);

    return () => clearInterval(checkAssistantStatus);
  }, []);

  const handleClick = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <>
      {/* Ocultar el botón original de Readdy */}
      <style>{`
        #vapi-widget-floating-button {
          display: none !important;
        }
      `}</style>

      {/* Botón personalizado */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="relative group cursor-pointer"
          aria-label="Abrir asistente virtual"
        >
          {/* Círculo de fondo con efecto de pulso */}
          <div className={`absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full transition-all duration-300 ${
            isHovered ? 'scale-110' : 'scale-100'
          }`}>
            <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full animate-ping opacity-75"></div>
          </div>

          {/* Contenedor del robot */}
          <div className="relative w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-2xl shadow-purple-500/50 transition-transform duration-300 hover:scale-110">
            {/* Robot SVG animado */}
            <div className={`relative transition-transform duration-300 ${isTalking ? 'animate-bounce' : ''}`}>
              {/* Cabeza del robot */}
              <div className="relative">
                {/* Antena */}
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-0.5 h-2 bg-white"></div>
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 bg-yellow-400 rounded-full animate-pulse"></div>
                
                {/* Cara */}
                <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-lg relative">
                  {/* Ojos */}
                  <div className="absolute top-3 left-2 flex gap-2">
                    <div className={`w-2 h-2 bg-blue-500 rounded-full transition-all duration-200 ${
                      isTalking ? 'animate-pulse' : ''
                    }`}></div>
                    <div className={`w-2 h-2 bg-blue-500 rounded-full transition-all duration-200 ${
                      isTalking ? 'animate-pulse' : ''
                    }`} style={{ animationDelay: '0.1s' }}></div>
                  </div>
                  
                  {/* Boca animada */}
                  <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2">
                    {isTalking ? (
                      <div className="flex gap-0.5">
                        <div className="w-1 bg-purple-500 rounded-full animate-wave" style={{ height: '4px', animationDelay: '0s' }}></div>
                        <div className="w-1 bg-purple-500 rounded-full animate-wave" style={{ height: '6px', animationDelay: '0.1s' }}></div>
                        <div className="w-1 bg-purple-500 rounded-full animate-wave" style={{ height: '4px', animationDelay: '0.2s' }}></div>
                      </div>
                    ) : (
                      <div className="w-4 h-1 bg-purple-500 rounded-full"></div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Indicador de micrófono cuando está activo */}
            {isTalking && (
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white animate-pulse">
                <i className="ri-mic-fill text-white text-xs"></i>
              </div>
            )}
          </div>

          {/* Tooltip */}
          <div className={`absolute bottom-full right-0 mb-2 px-4 py-2 bg-slate-900 text-white text-sm rounded-lg whitespace-nowrap shadow-xl transition-all duration-300 ${
            isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
          }`}>
            <div className="relative">
              ¿Necesitas ayuda? ¡Habla conmigo! 🤖
              <div className="absolute -bottom-1 right-4 w-2 h-2 bg-slate-900 transform rotate-45"></div>
            </div>
          </div>

          {/* Ondas de sonido cuando está hablando */}
          {isTalking && (
            <>
              <div className="absolute inset-0 rounded-full border-2 border-purple-400 animate-ping opacity-75"></div>
              <div className="absolute inset-0 rounded-full border-2 border-blue-400 animate-ping opacity-50" style={{ animationDelay: '0.3s' }}></div>
            </>
          )}
        </button>
      </div>

      {/* Animaciones personalizadas */}
      <style>{`
        @keyframes wave {
          0%, 100% { height: 4px; }
          50% { height: 8px; }
        }
        .animate-wave {
          animation: wave 0.6s ease-in-out infinite;
        }
      `}</style>
    </>
  );
}
